/*
 * @Author: Teemo Ding
 * @Date: 2021-12-03 14:44:10
 * @LastEditTime: 2022-08-04 11:05:59
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Discount/index.tsx
 */
import { Button, Input } from '@/src/components/Antd';
import { Form, message } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';
import DiscountSelections from '../DiscountSelections';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  handleApply: any;
  form: any;
  currency: any;
  //discountSelections: any;
  disable: boolean;
  disableApply?: boolean;
  disableDiscountSelections?: boolean;
  keyUuid: string;
  handleOnHasModified?: () => void;
  decimalPosition?: number;
  scTimezoneUTC?: string;
}

//const Discount = ({ handleApply, form, discountSelections, disable }) => {
const Discount = ({
  handleApply,
  form,
  currency,
  //discountSelections,
  disable,
  disableApply,
  disableDiscountSelections,
  keyUuid,
  handleOnHasModified,
  decimalPosition = 2,
  scTimezoneUTC = '',
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const addDiscountCodes = () => {
    const promoCode = form.getFieldValue('promoCode');
    const discountCodesOld = form.getFieldValue('discountCodes') || [];
    if ((discountCodesOld || []).includes(promoCode)) {
      message.error('promo code already exists with the same name.');
    } else {
      if (promoCode) {
        discountCodesOld.push(promoCode);
        form.setFieldsValue({
          promoCode: '',
          discountCodes: discountCodesOld,
        });
        handleApply();
      }
    }
  };

  const inputOnChange = (value) => {
    const reg = new RegExp(/^[A-Z0-9a-z,\\-]+$/);
    if (reg.test(value) || !value) {
      form.setFieldsValue({ promoCode: value.toUpperCase() });
    }
  };
  return (
    <SectionWrapper
      title={getI18n('general.discounts')}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      <Form.Item name='promoCode'>
        <Input
          onChange={inputOnChange}
          disabled={disable}
          size='large'
          placeholder={getI18n(
            'allOrders.orderDetail.additionalPromoCode_return_input_placeholder',
          )}
        />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) => {
          const cC = get(c, 'products');
          const pC = get(p, 'products');
          return cC !== pC;
        }}>
        {({ getFieldValue }: any) => (
          <Button
            type='primary'
            disabled={
              disable || !getFieldValue('products').length || disableApply
            }
            onClick={() => addDiscountCodes()}>
            {getI18n('general.advanceFilter.apply')}
          </Button>
        )}
      </Form.Item>
      {!disableDiscountSelections && (
        <div className={css.discountSelections}>
          <Form.List name='discountSelections'>
            {(fields, { add, move, remove }, { errors }) =>
              fields.map((item, index) => (
                <Form.Item name={[fields[index].name]}>
                  <DiscountSelections
                    key={index}
                    form={form}
                    currency={currency}
                    value={item || {}}
                    disabled={disable}
                    keyUuid={keyUuid}
                    reLoadDiscount={() => handleApply()}
                    handleOnHasModified={handleOnHasModified}
                    decimalPosition={decimalPosition}
                    scTimezoneUTC={scTimezoneUTC}
                  />
                </Form.Item>
              ))
            }
          </Form.List>
        </div>
      )}
    </SectionWrapper>
  );
};

export default Discount;
